export const getDocumentalManagementFields = {
    NUMERO_BP0: { campo: 'NUMERO_BP0', tipoCampo: 0, valor: '' },
    TIPO_IDENTIFICACION:  { campo: 'TIPO_IDENTIFICACION', tipoCampo: 0, valor: '' },
    NUMERO_DE_IDENTIFICACION:  { campo: 'NUMERO_DE_IDENTIFICACION', tipoCampo: 0, valor: '' },
    NOMBRE_COMPLETO_RAZON_SOCIAL:  { campo: 'NOMBRE_COMPLETO_RAZON_SOCIAL', tipoCampo: 0, valor: '' },
    TIPO_DOCUMENTAL:  { campo: 'TIPO_DOCUMENTAL', tipoCampo: 0, valor: '' },
    ID_PEDIDO_CLIENTE:  { campo: 'ID_PEDIDO_CLIENTE', tipoCampo: 0, valor: '' },
    CAJA:  { campo: 'CAJA', tipoCampo: 0, valor: '' },
    PAQUETE:  { campo: 'PAQUETE', tipoCampo: 0, valor: '' },
    DIGITADOR:  { campo: 'DIGITADOR', tipoCampo: 0, valor: '' },
    FECHA_ALMACENAMIENTO:  { campo: 'FECHA_ALMACENAMIENTO', tipoCampo: 0, valor: '' },
    CONTROL:  { campo: 'CONTROL', tipoCampo: 0, valor: '' },
    NOMBRE_ARCHIVO:  { campo: 'NOMBRE_ARCHIVO', tipoCampo: 0, valor: '' },
    DATAID:  { campo: 'DATAID', tipoCampo: 0, valor: '' },
    VERSION:  { campo: 'VERSION', tipoCampo: 0, valor: '' },
    CODIGO_TIPO_DOCUMENTAL:  { campo: 'CODIGO_TIPO_DOCUMENTAL', tipoCampo: 0, valor: '' },
    IDENTIFICADOR_SAP:  { campo: 'IDENTIFICADOR_SAP', tipoCampo: 0, valor: '' },
    IDDOCUMENTO_SAP:  { campo: 'IDDOCUMENTO_SAP', tipoCampo: 0, valor: '' },
    EXT_ARCHIVO:  { campo: 'EXT_ARCHIVO', tipoCampo: 0, valor: '' },
    FILE_SIZE:  { campo: 'FILE_SIZE', tipoCampo: 0, valor: '' },
    DESCRIPCION_TIPO_DOCUMENTAL:  { campo: 'DESCRIPCION_TIPO_DOCUMENTAL', tipoCampo: 0, valor: '' },
    FECHA_DOCUMENTO:  { campo: 'FECHA_DOCUMENTO', tipoCampo: 0, valor: '' },
    SOPORTE:  { campo: 'SOPORTE', tipoCampo: 0, valor: '' },
};